export const environment = {
  production: false,
  apiUrl: '/api',
  /** Absolute URL used during SSR (browser uses `apiUrl`). */
  //apiServerUrl: 'https://dev.api.careergradglobal.com/api',
  apiServerUrl: 'http://localhost:3000/api',
  googleClientId: '805324439582-sdjk9pgc4ig4n7vb20ev6d8k0bgdofpf.apps.googleusercontent.com',
};
